import React, { Component } from 'react';
import { Link } from 'react-router-dom';
// import SingleVideo from './singleVideo';


class SearchResults extends Component {
  constructor(props) {
    super(props);
    this.animate= true;
    this.screen = '';
    this.search='';
    this.currentFeat='';
    this.state = {
      featSlide: false,
      currentFeat:{},
      results: [],
      addPlace: this.props.active
    }; 
  }
  
  componentDidMount() {
    this.getResults();
    console.log('go')
  }

  componentDidUpdate(){
    this.getResults();
    //  this.props.checkMainURL();
  }
  
  // Retrieves the list of items from the Express app
  getResults = () => {
    var url = new URL(window.location.href);
    const result = url.searchParams.get("result")
    const search = url.searchParams.get("term");
    if(search){
    if (this.search !== search) {
      this.animate = false;
	    // var search = url.split('?')[1];
      fetch('/api/wsde-search?'+ search)
      .then(res => res.json())
      .then(results => this.setState({results},() => {
		      if (result) {
		        this.checkFeat(result);
		      }
	      }, 
	      this.setUpResults(),
	      this.search = search,
	    ));
    } else if(result && (result !== this.currentFeat)) {
      this.checkFeat(result);
    }
    }
  }
  
  checkFeat = (result) => {
    console.log(`Checkfeat: ${result}`);
    if (result !== this.currentFeat) {
      this.currentFeat = result
      this.grabFeature(parseInt(result))   
    }
  }
    
	setUpResults = () => {
    this.animate = true;    
  }

  grabFeature = (result) => {
    this.setState({currentFeat: (this.state.results[result])}, () => {
      this.setState({featSlide: true});
      var lat = this.state.currentFeat.lat;
      var lng = this.state.currentFeat.lng;
      var marker = this.state.currentFeat.id;
      this.moveMap(lat,lng, marker)
    });
    const currentFeat = this.state.currentFeat;
    console.log(currentFeat);
  }

  closeFeat = () => {
    var feat = document.getElementById('currentFeat');
    feat.classList.add('hideFeat')
  }

  openFeat = () => {
    var feat = document.getElementsByClassName('hideFeat')
    if(feat.length){
      feat[0].classList.remove('hideFeat')
    }
  }

  setFeat = (item) => {
    return(
      <div id="currentFeat" className="currentFeat">
        <div onClick={this.closeFeat} className="closeFeat marginBotSmall">×</div>
        <h2 className="marginBotTiny">{item.title}</h2>
        {item.address?(<p>{`${item.address}`}</p>):('')}
        <p className="marginBotMed ">{`${item.city}, ${item.state}`}</p>
        <a href={item.normURL} target="blank"><p className="numeroText">{item.website}</p></a>
        {item.phone?(<p className="numeroText">{`Phone: ${item.phone}`}</p>):('')}
        {item.email?(<a href={`mailto:${item.email}`}><p className="numeroText ">{`Email: ${item.email}`}</p></a>):('')}
      </div>
    )
  }

  setMap = (e) => {
    var lat = parseFloat(e.currentTarget.dataset.lat);
    var lng = parseFloat(e.currentTarget.dataset.lng);
    var marker = parseInt(e.currentTarget.dataset.marker);
    console.log(`M: ${marker}`);
    this.moveMap(lat,lng,marker);
    this.openFeat();
  }

  addForm = (e) => {
    this.props.addPlace();
  }

  moveMap = (lat,lng, marker) => {
    this.props.moveMap(lat,lng, marker);
  }

  render() {
    const { results } = this.state;
  
    return (
      <React.Fragment>
	      {this.state.featSlide ?(
	        <div className="featInfo fullWidth fullHeight">
	          {this.setFeat(this.state.currentFeat)}
	        </div>
	      ):(" ")}
	    	<div className="resultsHold fullWidth relative">
	        {results.length ? (
	          <div className="resultsField fullStage fullHeight">
	            {results.map((items,i) => {
	              return(
	                <Link 
	                	key={"results"+i}
	                	className={"resultSingle relative whiteT "+ (this.animate ? "animateOn":"animateOff")}
	                	style={{animationDelay: .075*i+"s"}}
	                	data-id={i}
	                	data-marker={items.id}
	                	data-lat={parseFloat(items.lat)}
	                	data-lng={parseFloat(items.lng)}
	                	onClick={this.setMap.bind(this)}
	                	to={"/dual-power-map/search?term="+this.search+"&result="+i}
	                >
		                <div className="fullWidth">
		                  <h2 className="fullWidth marginBotTiny">{items.title}</h2>
		                  <p className="upperT fullWidth numeroText">{`${items.city}, ${items.state}`}</p>
		                </div> 
	                </Link>
	              )
	            })}
	          </div>
	        ):(
            this.props.redirect?(
              <div className="addSomethingHold tfStage centeredContent blkT centerT upperT">
  	          <h3>
                Know something<br/>we don't?
              </h3>
              <Link className="addSomething" to="/dual-power-map/submit" onClick={this.addForm.bind(this)}>Add something</Link>
            </div>
            ):('')
            
	        )}
	      </div>
	    </React.Fragment>
	  )
  }
}
  
export default SearchResults;


// WEBPACK FOOTER //
// ./src/components/strategy/wsde/searchResults.js